import Cookies from "js-cookie";
let o = {
  set(name, value) {
    if (typeof value == "object") {
      Cookies.set(name, JSON.stringify(value));
      Cookies.set(name + "IsObj", "1");
    } else {
      Cookies.set(name, value);
      Cookies.set(name + "IsObj", "0");
    }
  },
  get(name) {
    if (Cookies.get(name + "IsObj") && Cookies.get(name + "IsObj") == "1") {
      return JSON.parse(Cookies.get(name));
    } else {
      return Cookies.get(name);
    }
  },
  remove(name) {
    Cookies.remove(name);
    Cookies.remove(name + "IsObj");
  },
};
export default o;
